import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const StripeConnectReturn = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Tenta abrir deep link do app
    const openDeepLink = () => {
      // Detecta se está em mobile
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      
      if (isMobile) {
        // Tenta abrir deep link do app
        const deepLink = 'ufokko://stripe-connect/success';
        
        // Tenta abrir o app via deep link
        window.location.href = deepLink;
        
        // Se não conseguir abrir após 2 segundos, mostra mensagem
        setTimeout(() => {
          // Verifica se ainda está na página (app não abriu)
          if (document.hasFocus()) {
            // Mostra mensagem para retornar ao app manualmente
            alert('Onboarding concluído! Por favor, retorne ao app para verificar o status.');
            // Tenta redirecionar para página de ajuda ou dashboard
            navigate('/');
          }
        }, 2000);
      } else {
        // Desktop - mostra mensagem
        alert('Onboarding concluído! Por favor, abra o app para verificar o status.');
        navigate('/');
      }
    };

    openDeepLink();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-blue-100 to-blue-50 dark:from-[#0F1629] dark:via-[#1A2332] dark:to-[#0F1629] flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-green-600 dark:text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            Onboarding Concluído!
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Você será redirecionado para o app em instantes...
          </p>
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
      </div>
    </div>
  );
};

export default StripeConnectReturn;
